<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
    <div class="container d-flex justify-content-between align-items-center">

      <div class="navbar-brand d-flex align-items-center">
        <img src="@/assets/africa.png"
             @click="sharedState.user_id !== null ? $router.push('home') : $router.push('/')"
             alt="Logo"
             width="40"
             height="40"
             class="d-inline-block align-top me-2"/>
        <div class="mx-3"
             @click="sharedState.user_id !== null ? $router.push('home') : $router.push('/')">
          <i class="bi bi-house-door"></i>
          <h6>{{ $t('Navbar.home') }}</h6>
        </div>
        <div class="mx-3"
             v-if="sharedState.user_id !== null"
             @click="$router.push('tutorials')">
          <i class="bi bi-mortarboard"></i>
          <h6>{{ $t('TutorialView.tutorials') }}</h6>
        </div>


      </div>
      <div class="center-text position-absolute text-center w-100">
        <span class="navbar-text fw-bold">{{ centerText }}</span>
      </div>

      <div class="d-flex align-items-center">
        <div class="dropdown me-3">
          <button class="btn btn-light dropdown-toggle p-1"
                  type="button"
                  id="languageDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
            <img :src="currentLanguage === 'en' ? require('@/assets/en.png') : require('@/assets/fr.png')"
                 alt="Current Language"
                 width="24"
                 height="16"/>
          </button>
          <div class="dropdown-menu"
               aria-labelledby="languageDropdown">
            <a class="dropdown-item d-flex align-items-center"
               @click="changeLanguage('en')">
              <img :src="require('@/assets/en.png')"
                   alt="English"
                   width="24"
                   height="16"
                   class="me-2"/>
              {{ $t('Navbar.english') }}
            </a>
            <a class="dropdown-item d-flex align-items-center"
               @click="changeLanguage('fr')">
              <img :src="require('@/assets/fr.png')"
                   alt="Français"
                   width="24"
                   height="16"
                   class="me-2"/>
              {{ $t('Navbar.french') }}
            </a>
          </div>
        </div>

        <div class="dropdown me-3"
             v-if="sharedState.user_id !== null">
          <button class="btn btn-light dropdown-toggle p-1"
                  type="button"
                  id="profileDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
            <img class="profile-picture"
                 :src="profileImage"
                 alt="Profile"/>
            <span class="navbar-text me-3">
              <strong>{{ sharedState.user_firstname }}</strong>
              ({{ sharedState.user_label }})
            </span>
          </button>
          <div class="dropdown-menu"
               aria-labelledby="profileDropdown">
            <a class="dropdown-item d-flex align-items-center"
               @click="$router.push('/profile')">
              {{ $t('ProfileSettingsView.profileSettings') }}
            </a>
            <a class="dropdown-item d-flex align-items-center"
               v-if="sharedState.user_isAdmin"
               @click="$router.push('/manage-users')">{{ $t('ManageUsersView.manageUsers') }}</a>
            <a class="dropdown-item d-flex align-items-center"
               v-if="sharedState.user_isAdmin"
               @click="$router.push('/manage-system')">{{ $t('ManageSystemView.manageSystem') }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item d-flex align-items-center"
               @click="logout()">
              {{ $t('Navbar.logout') }}
            </a>
          </div>
        </div>

      </div>
    </div>
  </nav>

  <template v-if="this.message">
    <div v-if="this.messageType === 'info'"
         class="alert alert-info"
         role="alert">
      <i class="bi bi-info-circle mx-1"></i>
      <strong>{{ $t('Navbar.info') }}:</strong> {{ this.message }}
    </div>

    <div v-if="this.messageType === 'success'"
         class="alert alert-success"
         role="alert">
      <i class="bi bi-check-circle mx-1"></i>
      <strong>{{ $t('Navbar.success') }}:</strong> {{ this.message }}
    </div>

    <div v-if="this.messageType === 'warning'"
         class="alert alert-warning"
         role="alert">
      <i class="bi bi-exclamation-circle mx-1"></i>
      <strong>{{ $t('Navbar.warning') }}:</strong> {{ this.message }}
    </div>

    <div v-if="this.messageType === 'danger'"
         class="alert alert-danger"
         role="alert">
      <i class="bi bi-exclamation-circle mx-1"></i>
      <strong>{{ $t('Navbar.error') }}:</strong> {{ this.message }}
    </div>
  </template>
</template>

<script>
import {sharedState} from "@/store";
import {useI18n} from "vue-i18n";
import {getUserImage, postLogout} from "@/utils";

export default {
  props: {
    centerText: {
      type: String,
      required: true,
      default: "",
    },
    message: {
      required: false,
      default: "",
    },
    messageType: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
  data() {
    return {
      currentLanguage: this.$i18n.locale,
      sharedState,
      profileImage: null,
    };
  },
  async beforeMount() {
    if (localStorage.getItem('access_token')) {
      const token = JSON.parse(atob(localStorage.getItem('access_token').split('.')[1]));
      this.sharedState.user_id = token['id'];
      this.sharedState.user_label = token['label'];
      this.sharedState.user_firstname = token['firstname'];
      this.sharedState.user_isAdmin = token['isAdmin'];
      this.sharedState.user_expiration = token['exp'];

      let response = await getUserImage(sharedState.user_id);
      if (response.status === 200) {
        this.profileImage = URL.createObjectURL(response.data);
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    }
  },
  methods: {
    async logout() {
      let response = await postLogout();
      if (response.status === 200) {
        localStorage.removeItem('access_token');
        this.sharedState.user_id = null;
        this.sharedState.user_label = null;
        this.sharedState.user_firstname = null;
        this.sharedState.user_isAdmin = null;
        this.sharedState.user_expiration = null;
      } else {
        this.message = response.response.data.message;
        this.messageType = 'danger';
      }
      this.$router.push({name: 'logout'});
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.currentLanguage = lang;
    },
  },
};
</script>
